export default "__VITE_ASSET__36273891__"